import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import CurvedContainer from '../../components/CurvedContainer';
import { Images } from 'util/images';
import { Wrapper, Container, SectionHeader } from '../../components';
import { Spinner } from '../../../components/Spinner/spinner';

import services from '../../../api/services';

const { ChallengeService } = services;

export default function RedirectPage({ match: { params } }) {
  const [loading, setLoading] = useState(true);
  const [subtitle, setSubtitle] = useState(undefined);

  const history = useHistory();

  useEffect(() => {
    setSubtitle(params?.redirectValue || 'missing redirect path');
    if (params?.redirectValue) {
      let checkRedirect = async () => {
        let result = await ChallengeService.getContestRedirectPath(params.redirectValue);
        if (result?._id) {
          history.push(`/challenges/${result._id}`);
        } else {
          setLoading(false);
          setSubtitle(`Could not find the /${params.redirectValue} page`);
        }
      };
      checkRedirect();
    }
  }, [params, history]);

  return (
    <Wrapper>
      <CurvedContainer bottom height={110} image={Images.tanks} />
      <Container column center>
        <SectionHeader bold>Redirect Page</SectionHeader>
        {subtitle && <SectionHeader>{subtitle}</SectionHeader>}
        {loading && <Spinner />}
      </Container>
    </Wrapper>
  );
}
